module.exports = __webpack_public_path__ + "static/img/event.5571799.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/event.jpg
// module id = 216
// module chunks = 1